export enum QuizEvent {
  QUIZ_COMPLETED = 'QUIZ_COMPLETED',
}
